import React from 'react';
import { PageHeader } from '@components/Shared/PageHeader';
import { TranslationTranscriptionContainer } from '@containers/TranslationTranscriptionContainer';
import { PageContainer } from './TranslationTranscription.styles';

export default function TranslationTranscription() {
  return (
    <PageContainer>
      <PageHeader 
        title="Translation & Transcription" 
        description="Transcribe and Translate Documents"
      />
      <TranslationTranscriptionContainer />
    </PageContainer>
  );
}